import { b as bem } from './p-g1JgJ7wn.js';
import { h } from './p-BJEvNVLM.js';

const generateClassNames = bem('cosmos-live-icon-animated');
const CosmosLiveIconAnimated = ({ class: classname, slot, }) => {
    return (h("div", { class: [generateClassNames(), classname].join(' '), slot: slot },
        h("div", { class: generateClassNames('dot') })));
};

export { CosmosLiveIconAnimated as C };
